import { TradeOrderService_tradeOrderVersionServiceGetEntity } from '@festina/unitlink-general-types/unitlink/hooks/TradeOrderService_tradeOrderVersionServiceGetEntity'

export const useFetchTradeOrders =
  TradeOrderService_tradeOrderVersionServiceGetEntity.useSuspenseQuery
